var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBottomBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 103,
    viewBox: "0 0 430 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 103V25.982H128.302C165.268 25.7416 179.841 12.527 189.304 7.48374C198.847 2.39591 207.585 0 215.065 0C222.546 0 233.292 2.94524 240.92 7.48374C248.549 12.0222 264.664 25.982 302.72 25.982H430V103H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBottomBar);
export default __webpack_public_path__ + "static/media/ic-bottomBar.b57b61c6b737886aa13dceecbd526b3e.svg";
export { ForwardRef as ReactComponent };